import { render, staticRenderFns } from "./user-agreement.vue?vue&type=template&id=29fe80d0&scoped=true&"
import script from "./user-agreement.vue?vue&type=script&lang=js&"
export * from "./user-agreement.vue?vue&type=script&lang=js&"
import style0 from "./user-agreement.vue?vue&type=style&index=0&id=29fe80d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fe80d0",
  null
  
)

export default component.exports